module.exports = __webpack_public_path__ + "static/media/welcome-tts.f4777dfc.svg";